import styled from "styled-components"
import { TableCell, TableCellProps, TableSortLabel } from "@mui/material"
import React, { ReactNode } from "react"
import { TextBold } from "../../../atoms/text"
import { theme } from "../../../../theme"
import { SortDirection } from "../types/SortDirection"

export type THeadCellProps = {
  name?: string
  align?: TableCellProps["align"]
  onClick?: (name: string) => void
  active?: boolean
  direction?: SortDirection
  children?: ReactNode
  className?: string
  dataCy?: string
}

export const THeadCell = (props: THeadCellProps) => {
  const { name, align, onClick, children, active = false, direction, className, dataCy } = props

  return (
    <CustomCell align={align} className={className} data-cy={dataCy}>
      {!!onClick && (
        <CustomSortLabel active={active} direction={direction} onClick={() => !!onClick && onClick(name ?? "")}>
          <CustomTextLabel color="inherit">{children}</CustomTextLabel>
        </CustomSortLabel>
      )}

      {!onClick && <CustomTextLabel>{children}</CustomTextLabel>}
    </CustomCell>
  )
}

const CustomCell = styled(TableCell)`
  color: ${theme.color.grey2};

  &:not(:first-child) {
    padding-left: 0;
  }

  &:first-child {
    padding-left: ${theme.spacing.lx};
  }
`

const CustomTextLabel = styled(TextBold)`
  color: ${theme.color.grey2};
  min-height: 1px;
  vertical-align: middle;
  line-height: inherit;
  display: inline-flex;
`

const CustomSortLabel = styled(TableSortLabel)`
  & .MuiTableSortLabel-icon {
    color: ${theme.color.grey2} !important;
  }
`
